export const surveyQuestions = [
  { id: "satisfaction1", text: "本次服務符合本身之需求" },
  { id: "satisfaction2", text: "服務過程感受到被尊重" },
  { id: "satisfaction3", text: "工作人員所提供之服務滿意度" },
  { id: "satisfaction4", text: "對於服務過程有疑慮可獲得適當的解答" },
];

export const surveyOptions = ["不用做", "非常不滿意", "不滿意", "普通", "滿意", "非常滿意"];
